module.exports = "/_next/static/images/4bf3d406dcce068b55d4ee350821c35b-apple.svg.webp";